import { showAlertError, showAlertExito } from '../utils/alertHelper';
import axiosInstance from "./axiosInstance";

const usuarios = 'usuarios';

// listando usuarios
export const listUsuarios = async () => {
    try {
        const response = await axiosInstance.get(`/${usuarios}/list`);
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};

// listando usuarios
export const listUsuariosLazy = async (page, limit, buscar) => {
    try {
        const response = await axiosInstance.get(`/${usuarios}/lazy/${page}/${limit}/${buscar}`);
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};

// Crear nueva suarios
export const createUsuarios = async (data) => {
    try {
        const response = await axiosInstance.post(`/${usuarios}/create`, data);
        showAlertExito("¡Éxito!", "usuario creado exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};

// Crear nueva suarios desde el formulario de registro
export const createUsuariosForm = async (data) => {
    try {
        const response = await axiosInstance.post(`/${usuarios}/createform`, data);
        showAlertExito("¡Éxito!", "usuario creado exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};

// Actualizar usuario
export const updateUsuarios = async (id, data) => {
    try {
        const response = await axiosInstance.put(`/${usuarios}/edit/${id}`, data);
        showAlertExito("¡Éxito!", "Usuario actualizado exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};

// Cambiar estado usuario
export const changeUsuarios = async (id, data) => {
    try {
        const response = await axiosInstance.patch(`/${usuarios}/change/${id}`, data);
        showAlertExito("¡Éxito!", "Estado actualizado exitosamente");
        return response.data;
    } catch (error) {
        showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
    }
};
// Olvidar contraseña
export const forgotPassword = async (data) => {
    try {
        const response = await axiosInstance.post(`/${usuarios}/forgot-password`, data);
        if (response.data.status === 1) {
            showAlertExito("¡Éxito!", response.data.msg || "Se ha enviado una contraseña temporal a tu correo");
        } else {
            showAlertError("Aviso", response.data.msg || "Correo no encontrado");
        }
        return response.data;
    } catch (error) {
        console.error("Error en forgot password:", error);
        showAlertError("Error inesperado", "Ocurrió un problema al intentar enviar el correo.");
    }
};

// Enviar código de verificación al correo
export const enviarCodigoCorreo = async (data) => {
    try {
        const response = await axiosInstance.post(`/${usuarios}/codigo-correo`, data);
        return response.data;
    } catch (error) {
        console.error("Error al enviar código:", error);
        return { status: 0, msg: "Ocurrió un problema al enviar el código." };
    }
};

// Verificar el código enviado al correo
export const verificarCodigo = async (data) => {
    try {
        const response = await axiosInstance.post(`/${usuarios}/codigo-verificacion`, data);
        return response.data;
    } catch (error) {
        console.error("Error al verificar código:", error);
        return { status: 0, msg: "Ocurrió un problema al verificar el código." };
    }
};

// Enviar notificación de ayuda
export const enviarNotificacionAyuda = async (data) => {
    try {
        const response = await axiosInstance.post(`/${usuarios}/notificacion-ayuda`, data);
        return response.data;
    } catch (error) {
        console.error("Error al enviar notificación de ayuda:", error);
        return { status: 0, msg: "Ocurrió un problema al enviar la solicitud de ayuda." };
    }
};

